import { DeepKeys, DeepValue, useForm } from '@tanstack/react-form';
import { Input } from './input';
import { cn } from '@/utils/Utils';

type FormInputFieldProps<TFormData extends Record<string, any>> = {
  formApi: any;
  name: DeepKeys<TFormData>;
  label: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function FormInputField<TFormData extends Record<string, any>>({
  formApi,
  name,
  label,
  required,
  ...rest
}: FormInputFieldProps<TFormData>) {
  return (
    <formApi.Field
      name={name}
      children={(field: any) => {
        const isError = Boolean(field.state.meta.errors.length);

        return (
          <div className={rest.className ?? ''}>
            <div className="group relative">
              <label
                htmlFor={name}
                className="origin-start text-muted-foreground/70 group-focus-within:text-foreground has-[+input:not(:placeholder-shown)]:text-foreground absolute top-1/2 block -translate-y-1/2 cursor-text px-1 text-sm transition-all group-focus-within:pointer-events-none group-focus-within:top-0 group-focus-within:cursor-default group-focus-within:text-xs group-focus-within:font-medium has-[+input:not(:placeholder-shown)]:pointer-events-none has-[+input:not(:placeholder-shown)]:top-0 has-[+input:not(:placeholder-shown)]:cursor-default has-[+input:not(:placeholder-shown)]:text-xs has-[+input:not(:placeholder-shown)]:font-medium"
              >
                <span className="inline-flex px-1 mx-1 bg-[linear-gradient(to_top,_white_51%,_transparent_50%)]">
                  {label}
                </span>
              </label>
              <Input
                id={name}
                key={name}
                name={name}
                placeholder=" "
                value={field.state.value as string | number | readonly string[] | undefined}
                onChange={(e) => field.handleChange(e.target.value as DeepValue<TFormData, typeof name>)}
                onBlur={field.handleBlur}
                className={cn(
                  isError &&
                    'border-red-600/80 text-red-600 focus-visible:border-red-600/80 focus-visible:ring-red-600/20',
                )}
                {...rest}
              />
            </div>
            {isError && (
              <p className={cn('mt-1 text-xs text-red-600')} role="alert" aria-live="polite">
                {field.state.meta.errors
                  .map((error: unknown) =>
                    typeof error === 'string' ? error : (error as { message?: string })?.message,
                  )
                  .filter(Boolean)
                  .join(', ')}
              </p>
            )}
          </div>
        );
      }}
    />
  );
}
